export default function getCurveLength(curve, resolution)
{
    const step = 1 / resolution;

    let prev = curve.getPointAt(0);
    let distance = 0;
    for (let i=1; i < resolution; i ++)
    {
        const curr = curve.getPointAt(i * step);
        distance += curr.clone().sub(prev).length();
        prev = curr;
    }

    return distance;
}
